import React from 'react';

function PrivacyPolicy() {
  return (
    <div className="legal-page page">
      <div className="white-wrapper">
        <div className='terms-container'>
          <h4>Privacy Policy</h4>
          <p><em>Last updated: 15/5/2025</em></p>

          <strong>1. No Personal Information Collected</strong>
          <p>We do not collect, store, or share any personal information from users.</p>

          <strong>2. No Tracking</strong>
          <p>We do not use cookies, advertising tools, analytics services, or third-party tracking technologies on this website.</p>

          <strong>3. Local Progress Storage</strong>
          <p>Any learning progress, such as signs marked as learned, is saved only on your device using your browser’s local storage. This information is not sent or accessible to us.</p>

          <strong>4. No Account or Login</strong>
          <p>You are not required to create an account or provide any personal details to use SignMates. All features are accessible without registration.</p>

          <strong>5. External Links</strong>
          <p>Some pages may link to external educational resources. These sites have their own privacy policies. Please review them if you choose to visit those links.</p>

          <strong>6. Children’s Privacy</strong>
          <p>SignMates is designed to be safe for children. We do not collect or store any data from children or identifiable information.</p>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
